var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnilevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 34C0 15.2223 15.2223 0 34 0C52.7777 0 68 15.2223 68 34C68 52.7777 52.7777 68 34 68C15.2223 68 0 52.7777 0 34ZM22.4122 23.0527H18.546H14.6797V26.9164V30.78H18.546V26.9164H22.4122V23.0527ZM30.1335 23.0527H26.2672V26.9164H30.1335V30.78H33.9998V26.9164H37.866V23.0527H33.9998H30.1335ZM41.7172 23.0527H45.5835V26.9164V30.78H41.7172V26.9164V23.0527ZM49.4498 23.0527H53.3161V26.9164V30.78H49.4498V26.9164V23.0527ZM14.6797 33.3555H18.546V37.2191V41.0827H22.4122V44.9464H18.546H14.6797V41.0827V37.2191V33.3555ZM30.1335 33.3555H33.9998V37.2191V41.0827V44.9464H30.1335V41.0827V37.2191V33.3555ZM49.4498 33.3555H45.5835V37.2191H41.7172V41.0827V44.9464H45.5835V41.0827V37.2191H49.4498V41.0827V44.9464H53.3161V41.0827V37.2191H49.4498V33.3555Z",
    fill: "url(#paint0_linear_2159_2249)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2159_2249",
    x1: 68,
    y1: -0.00000386504,
    x2: 3.1553,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AF79E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9945FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnilevel);
export default __webpack_public_path__ + "static/media/unilevel.8a0a8a1405a6c40e18e3edac6b103b95.svg";
export { ForwardRef as ReactComponent };